import {
  faAnglesLeft,
  faAnglesRight,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';

import { Button } from '@/ui/Button';

import { cn } from '../lib/utils';

interface PaginatorProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  showFirstLast?: boolean;
  className?: string;
}

function Paginator({
  currentPage,
  totalPages,
  onPageChange,
  showFirstLast = true,
  className
}: PaginatorProps) {
  const isFirst = currentPage <= 1;
  const isLast = currentPage >= totalPages;

  return (
    <nav aria-label="Pagination" className={cn('flex items-center gap-1', className)}>
      {showFirstLast && (
        <Button
          variant="ghost"
          color="neutral"
          size="sm"
          leftIcon={faAnglesLeft}
          disabled={isFirst}
          onClick={() => onPageChange(1)}
          aria-label="First page">
          First
        </Button>
      )}

      <Button
        variant="default"
        color="secondary"
        size="sm"
        leftIcon={faChevronLeft}
        disabled={isFirst}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label="Previous page">
        Prev
      </Button>

      <span className="text-sm text-uniform-gray-600 dark:text-uniform-gray-400 select-none tabular-nums px-2">
        Page {currentPage} of {totalPages}
      </span>

      <Button
        variant="default"
        color="secondary"
        size="sm"
        rightIcon={faChevronRight}
        disabled={isLast}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label="Next page">
        Next
      </Button>

      {showFirstLast && (
        <Button
          variant="ghost"
          color="neutral"
          size="sm"
          rightIcon={faAnglesRight}
          disabled={isLast}
          onClick={() => onPageChange(totalPages)}
          aria-label="Last page">
          Last
        </Button>
      )}
    </nav>
  );
}

export { Paginator };
export type { PaginatorProps };
